var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5477 10.1442L14.918 14.5205C15.0304 14.6333 15.0269 14.8125 14.9098 14.921C14.8527 14.9737 14.7795 15 14.706 15C14.6286 15 14.5516 14.9711 14.4939 14.9131L10.113 10.526C9.04358 11.3798 7.67152 11.8944 6.17651 11.8944C2.7706 11.8944 0 9.22667 0 5.94721C0 2.66775 2.7706 0 6.17651 0C9.58241 0 12.353 2.66775 12.353 5.94721C12.353 7.58383 11.6624 9.0678 10.5477 10.1442ZM0.587769 5.94729C0.587769 8.91438 3.09455 11.3281 6.17604 11.3281C9.25723 11.3281 11.7643 8.91438 11.7643 5.94729C11.7643 2.9802 9.25753 0.566483 6.17604 0.566483C3.09455 0.566483 0.587769 2.9802 0.587769 5.94729Z",
    fill: "#9B9B9B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.6fac08b5cce378a8d66edc2b3b21ae5f.svg";
export { ForwardRef as ReactComponent };